import { Injectable } from '@angular/core';
import { User } from '../../modules/account-data/user.model';
import { Features } from '../../modules/features-data/sub-models/features.model';
import { ProvisioningSubscription } from '../../modules/features-data/sub-models/provisioning-subscription.model';
import { Toggles } from '../../modules/features-data/sub-models/toggles.model';
import { TrackingPaymentsStatusEnum } from '../../modules/tracking/tracking.data';
import { Settings } from '../../modules/settings-data/settings.model';
import { ITrackingProperties } from 'i2g-ng-tracking';
import { TrackingBuilder } from '../../modules/tracking/tracking.builder';

interface IAppTrackingTraitsParams {
  accountId: string;
  userId: string;
  user: User;
  settings: Settings;
  features: Features;
  subscription: ProvisioningSubscription;
}

@Injectable()
export class AppBuilder {
  constructor(private _trackingBuilder: TrackingBuilder) {}

  buildAppTrackingTraits(
    params: IAppTrackingTraitsParams
  ): ITrackingProperties {
    const {
      accountId,
      userId,
      user,
      features,
      subscription,
      settings,
    } = params;

    const featureToggles = features.toggles;
    const currentPlan = subscription.currentPlan;
    const paymentsSettings = settings.companySettings.payments;
    let paymentsStatus = '';

    if (
      !featureToggles.isAllAccess(Toggles.KEYS.CARD_PAYMENTS) ||
      !paymentsSettings.allowedByPartner
    ) {
      paymentsStatus = TrackingPaymentsStatusEnum.ineligible;
    } else {
      paymentsStatus = paymentsSettings.enabledByUser
        ? TrackingPaymentsStatusEnum.on
        : TrackingPaymentsStatusEnum.off;
    }

    return this._trackingBuilder.buildTraits({
      accountId,
      userId,
      email: user ? user.email : '',
      country: settings.companySettings.country,
      currencyCode: settings.documentPresetSettings.currencyCode,
      cardPaymentsStatus: paymentsStatus,
      purchaseWindow: currentPlan.window,
      expirationDate: currentPlan.expiryDateUtc,
      planUuid: currentPlan.planUuid,
    });
  }
}
